import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    aiTools: {},
    sideNavAiTools: {}
}

const aiToolsSlice = createSlice({
    name: 'aiTools',
    initialState,
    reducers: {
        setAiTools: (state, action) => {
            action.payload.forEach(aiTool => {
                state.aiTools[aiTool.name] = aiTool
            })
        },
        setSideNavAiTools: (state, action) => {
            state.sideNavAiTools = action.payload
        },
        resetAiTools: () => initialState,
    }
})

export const { setAiTools, resetAiTools,setSideNavAiTools } = aiToolsSlice.actions
export default aiToolsSlice.reducer
